import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=361db4bd&scoped=true&"
import script from "./Integral.vue?vue&type=script&lang=js&"
export * from "./Integral.vue?vue&type=script&lang=js&"
import style0 from "./Integral.vue?vue&type=style&index=0&id=361db4bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361db4bd",
  null
  
)

export default component.exports